import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Interactive row / list hover wash.
 * Light muted grey — readable on white without the heavy sidebar-accent wash,
 * and still a clear step up from the muted/40 feature canvas.
 */
export const interactiveHoverClassName = 'hover:bg-muted'
